















































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import ContentForm from './contentForm.vue';
import QuotationForm from './quotationForm.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT, CHANGE_SOLUTION_STATUS } from '@/utils/pubsub';
import { convertJsonData } from '@/utils/payment';

type IUpdatePaymentData = IPayment.IRequest.IUpdatePaymentData;

const generateNewContent = (): IPayment.IContentData => {
  return {
    rewardModule: {
      rewardType: '',
      rewardContent: '',
    },
    saveTimeModule: {
      usageTimes: '',
      saveTime: '',
      affectDepcount: '',
      peopleCount: '',
      calcContent: '',
      remarks: '',
    },
    manDayModule: {
      manDay: 0,
    },
    requirementModule: {
      project: '',
      description: '',
      name: '',
      num: '',
      manDayStatus: '',
      follower: '',
      due: null,
    },
  };
};
const generateRandom = (): string => {
  return Math.random().toString().substr(2, 6);
};

@Component({
  components: {
    ContentForm,
    QuotationForm,
  },
})
export default class PaymentForm extends Vue {
  @Prop({required: true}) private paymentInfo!: IUpdatePaymentData;
  @Prop({required: true}) private submit!: (
    updateInfo: IUpdatePaymentData,
  ) => Promise<string>;
  @Ref() private readonly quotationForm!: QuotationForm;
  private submitLoad = false;
  private contentList: IPayment.IContentData[] = [];
  private paymentTitle = '';
  private paymentType: IPayment.IRewardType = 0;
  private quotations: IPayment.IQuotationItem[] = [];
  private manDay = 0;
  @Watch('quotations')
  private watchQuotations(items: IPayment.IQuotationItem[]) {
    let total = 0;
    items.forEach((item) => {
      total += item.manDay;
    });
    this.manDay = total;
  }
  private created() {
    this.initFormData();
  }
  private initFormData() {
    this.contentList = convertJsonData(this.paymentInfo.jsonData);
    this.contentList.forEach((content) => {
      content.id = generateRandom();
    });
    if (this.contentList.length === 0) {
      this.addContent();
    }
    this.paymentTitle = this.paymentInfo.title;
    this.paymentType = 0;
    this.quotations = this.paymentInfo.items.map((item) => item);
  }
  private handleSubmit() {
    this.contentList.forEach((item, index) => {
      (this.$refs[`contentRef-${index}`] as ContentForm[])[0].updateContent();
    });
    if (!this.paymentTitle) {
      this.$message.warning('请填写标题');
      return;
    }
    if (this.quotations.length < 1) {
      this.$message.warning('请添加报价单');
      return;
    }
    const data: IPayment.IRequest.IUpdatePaymentData = {
      title: this.paymentTitle,
      items: this.quotations,
      type: this.paymentType,
      jsonData: JSON.stringify(this.contentList),
    };
    this.submitLoad = true;
    this.submit(data).then((res) => {
      this.$message.success(res);
      this.updateQuotationsStatus('Block');
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.submitLoad = false;
    });
  }
  private updateQuotationsStatus(status: ISolution.ISolutionStatus) {
    const solutionIds = this.quotations.map((item) => item.quotationId);
    pubsub.publish(CHANGE_SOLUTION_STATUS, {
      solutionIds,
      status,
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({
      name: 'Payment',
    });
  }
  private addContent() {
    const newContent = generateNewContent();
    newContent.id = generateRandom();
    this.contentList.push(newContent);
  }
  private removeContent(index: number) {
    this.contentList.splice(index, 1);
  }
  private handleAddQuotation() {
    this.quotationForm.showModal();
  }
  private handleRemoveQuotation(index: number) {
    this.quotations.splice(index, 1);
  }
  private updateQuotation(value: IPayment.IQuotationItem[]) {
    const quotationIds = value.map((quotation) => quotation.quotationId);
    const newQuotations: IPayment.IQuotationItem[] = this.quotations.filter((quotation) => {
      return !quotationIds.includes(quotation.quotationId);
    });
    this.quotations = [...newQuotations, ...value];
  }
}
